import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import headerLogo from '../../img/defi-logo-color.png';
import poweredLogo from '../../img/powered-by-logo.png';
import { PATH_ROOT } from '../../paths';

const styles = {
  paper: {
    marginTop: '50px',
    padding: '60px 30px ',
    fontSize: '14px',
  },
  button: {
    margin: '20px 0 10px',
  },
  link: {
    textDecoration: 'none',
  },
  bottom: {
    marginTop: '20px',
  },
  logo: {
    paddingBottom: '20px',
  },
};

class NotFound extends Component {
  render() {
    return (
      <div className="col-xs-10 col-sm-6 col-md-4 col-lg-4">
        <div className="box">
          <Paper elevation={3} style={styles.paper}>
            <div className="row center-xs">
              <div className="col-xs-12">
                <div className="box" style={styles.logo}>
                  <img src={headerLogo} alt="logo" />
                </div>
              </div>
              <div className="col-xs-8">
                <div className="box">
                  <h2>Page Not Found</h2>
                  <p>Sorry but the page you are looking for cannot be found.</p>
                  <Button
                    variant="contained"
                      id="go-home-button"
                    style={styles.button}
                    color="primary"
                    onClick={() => this.props.history.push(PATH_ROOT)}
                  >
                    Go Home
                  </Button>
                </div>
              </div>
            </div>
          </Paper>
          <a href="http://defisolutions.com" target="_blank" rel="noopener noreferrer">
            <img src={poweredLogo} style={styles.bottom} alt="logo" />
          </a>
        </div>
      </div>
    );
  }
}

export default NotFound;
